module.exports = "/_next/static/images/buy-3d30ff93480dcb3318a28c203263e97a.svg";